import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import type { TcgplayerBoard } from "./tcgplayer-shared";

/**
 * Live TCGplayer seller offers and completed sales for one printed card code.
 * Public and read-only: the same marketplace data the card's TCGplayer link
 * leads to, surfaced on Pal Stars so a reader can compare it with eBay first.
 */
export const getCardTcgplayer = createServerFn({ method: "GET" })
  .inputValidator((data: unknown) => z.object({ code: z.string().min(3).max(24) }).parse(data))
  .handler(async ({ data }): Promise<TcgplayerBoard> => {
    const { readCardTcgplayer } = await import("./tcgplayer-public.server");
    return await readCardTcgplayer(data.code);
  });
